import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

export default async () => {
  const token = getToken();

  let valid = false;
  let data = [];
  let biotemplateResult;

  if (token) {
    try {
      const response = await fetch(`${BASE_URL}/api/card_biotemplates`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      biotemplateResult = await response.json();
      valid = biotemplateResult && biotemplateResult.success;

      data = biotemplateResult.card_biotemplates;
    } catch (except) {
      valid = false; // network error
    }
  } else {
    return null; // No token
  }

  if (!valid) {
    if (biotemplateResult && biotemplateResult.error) {
      return {
        valid: false,
        message: biotemplateResult.error,
      };
    }
    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }

  return {
    valid: true,
    data,
  };
};
